import _ from "lodash";
import React from "react";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import I18nHOC from "UIComponents/I18nHOC";
import classes from "./DateDurationSelector.scss";
import moment from "moment";
import { DatePicker } from "@toddle-edu/ds-web";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";

class DateDurationSelector extends UIBaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount = () => {
    const {
      value: { endDate, startDate },
      maxDate,
      minDate,
    } = this.props;

    const isStartDateValid = moment(startDate).isValid();
    const isEndDateValid = moment(endDate).isValid();

    // if start and end date is not valid and then set them equal to
    // start and end date of Academic Year
    if (!isStartDateValid && !isEndDateValid) {
      this.changeDate({ startDate: minDate, endDate: maxDate });
      return;
    }

    if (moment(endDate).isAfter(moment(maxDate)) || !isEndDateValid) {
      this.changeDate({ endDate: maxDate });
    }

    if (moment(startDate).isBefore(moment(minDate)) || !isStartDateValid) {
      this.changeDate({ startDate: minDate });
    }
  };

  changeDate = params => {
    const {
      value,
      maxDate,
      minNumOfDays,
      shouldChangeEndDateWithStartDate,
      minDate,
    } = this.props;

    const { endDate } = value;

    if (
      _.has(params, "startData") &&
      moment(params.startDate).isBefore(moment(minDate))
    ) {
      params["startDate"] = minDate;
    }

    if (
      _.has(params, "startDate") &&
      moment(params.startDate).isAfter(moment(endDate))
    ) {
      params["endDate"] = moment(params.startDate).add(minNumOfDays, "days");
    }

    // When we need the end Date to be made start Date + minNumOfDays, automatically when startDate is changed
    //        shouldChangeEndDateWithStartDate = true
    //        the number of days difference between dates = minNumOfDays
    //
    if (_.has(params, "startDate") && shouldChangeEndDateWithStartDate) {
      params["endDate"] = moment(params.startDate).add(minNumOfDays, "days");
    }

    if (
      _.has(params, "endDate") &&
      moment(params.endDate).isAfter(moment(maxDate))
    ) {
      params["endDate"] = maxDate;
    }

    // Format start and end dates to "YYYY-MM-DD"
    if (_.has(params, "startDate")) {
      params["startDate"] = moment(params.startDate).format("YYYY-MM-DD");
    }
    if (_.has(params, "endDate")) {
      params["endDate"] = moment(params.endDate).format("YYYY-MM-DD");
    }

    this.updateValue({ ...value, ...params });
  };

  isValid = () => {
    // check if both startDate and endDate are valid and endDate is after startDate
    const {
      value: { startDate, endDate },
    } = this.props;
    return !(
      moment(startDate).isValid() &&
      moment(endDate).isValid() &&
      moment(endDate).isAfter(moment(startDate))
    );
  };

  renderEdit = () => {
    const {
      t,
      minDate,
      maxDate,
      startDateLabel,
      endDateLabel,
      startDateName,
      endDateName,
      startDatePlaceholder,
      endDatePlaceholder,
      value: { startDate, endDate },
      isDisabled,
      size,
      testId,
    } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.dateContainer}>
          <DatePicker
            label={
              _.isEqual(startDateLabel, "common:start_date")
                ? t(startDateLabel)
                : startDateLabel
            }
            onChange={date => this.changeDate({ [startDateName]: date })}
            format="DD MMM YYYY"
            value={moment(startDate)}
            minDate={moment(minDate)}
            maxDate={moment(maxDate)}
            disabled={isDisabled}
            size={size}
            placeholder={
              _.isEqual(startDatePlaceholder, "common:start_date")
                ? t(startDatePlaceholder)
                : startDatePlaceholder
            }
            testId={`${testId}-startDate`}
          />
        </div>
        <div className={classes.dateContainer}>
          <DatePicker
            label={
              _.isEqual(endDateLabel, "common:end_date")
                ? t(endDateLabel)
                : endDateLabel
            }
            onChange={date =>
              this.changeDate({ [endDateName]: date.format("YYYY-MM-DD") })
            }
            format="DD MMM YYYY"
            value={moment(endDate)}
            minDate={moment(startDate)}
            maxDate={moment(maxDate)}
            disabled={isDisabled}
            size={size}
            placeholder={
              _.isEqual(endDatePlaceholder, "common:end_date")
                ? t(endDatePlaceholder)
                : endDatePlaceholder
            }
            startDate={moment(startDate)}
            testId={`${testId}-endDate`}
          />
        </div>
      </div>
    );
  };

  renderView = () => {
    const {
      value: { startDate, endDate },
    } = this.props;
    const formattedDate = `${moment(startDate).format(
      DATE_TIME_CONSTANTS.D_MMM
    )} - ${moment(endDate).format(DATE_TIME_CONSTANTS.D_MMM_YYYY)}`;
    return <div className={"text-body-2"}>{formattedDate}</div>;
  };
}

DateDurationSelector.defaultProps = {
  ...UIBaseComponent.defaultProps,
  minDate: null,
  maxDate: null,
  isDisabled: false,
  value: { startDate: null, endDate: null },
  startDateLabel: "common:start_date",
  endDateLabel: "common:end_date",
  startDateName: "startDate",
  endDateName: "endDate",
  startDatePlaceholder: "common:start_date",
  endDatePlaceholder: "common:end_date",
  minNumOfDays: 40,
  size: "large",
  shouldChangeEndDateWithStartDate: false,
};

DateDurationSelector.propTypes = {
  ...UIBaseComponent.propTypes,
};

DateDurationSelector.displayName = "DateDurationSelector";

export default I18nHOC({ resource: ["common"] })(DateDurationSelector);
